import { Injectable } from "@angular/core";

import { AngularFireDatabase } from "angularfire2/database";

@Injectable()
export class FirebaseService {
  
constructor(private firebaseDB: AngularFireDatabase) {}

	getPlayerById(playerId: string) { return this.firebaseDB.database.ref(`/players/${playerId}`); }	
  getRanking(rankType: string, numRecords: number) { 
		return this.firebaseDB.database.ref(`/rankings/${rankType}`).orderByValue().limitToLast(numRecords); 
	}
	
}


// WEBPACK FOOTER //
// ./src/providers/firebase-service.ts